import {Space} from "antd";
import {SubscriptionCheckoutFormGroups} from "../../accordion/data";
import {OfferingFormAccordionItem} from "../../accordion/accordion-item";
import {SubscriptionCheckoutFormFieldsProps} from "./types";

export function SubscriptionCheckoutFormFields({
  isBookingQuestionsError,
}: SubscriptionCheckoutFormFieldsProps) {
  return (
    <Space direction="vertical" size={16} style={{display: "flex"}}>
      {SubscriptionCheckoutFormGroups.map((fg, index) => {
        if (fg.title === "Checkout form") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={!!isBookingQuestionsError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        }
        return null;
      })}
    </Space>
  );
}
